import { getPromptModuleRouteFullUrl, promptFormsId, PromtRedirectStatus } from "../const/promptFormsId"
import { Team } from "@brg/api";
import { useCallback, useEffect, useMemo, useState } from "react";

type PropsT = Pick<Team, "teamId" | "membersIDs" | "ownersIDs" > & { designerId?: string };

export const useRedirectToPromptForms = ({ teamId, membersIDs, ownersIDs, designerId }: PropsT) => {
    const [redirectStatus, setRedirectStatus] = useState<PromtRedirectStatus>(PromtRedirectStatus.default)

    const formId = (promptFormsId[teamId as keyof {}] ?? '') as string; 
    const moduleRoute = getPromptModuleRouteFullUrl(formId);

    const isOwner = useMemo(() => {
        if (designerId && ownersIDs) {
            return ownersIDs?.includes(designerId ?? '')
        }
        return null
    } , [designerId, ownersIDs])

    const participant = useMemo(() => {
        if (designerId && membersIDs) {
            return membersIDs?.includes(designerId ?? '')
        }
        return null
    } , [designerId, membersIDs])

    const init = useCallback(() => {
        if (isOwner !== null && participant !== null && (isOwner || participant)) {
            setRedirectStatus(PromtRedirectStatus.member)
        } else {
            setRedirectStatus(PromtRedirectStatus.notMember)
        }
    } , [isOwner, participant, designerId])

    useEffect(() => {
        init()
    } , [isOwner, participant, designerId])

    useEffect(() => {
        if (redirectStatus === PromtRedirectStatus.member && formId && moduleRoute) {
            window.location.href = moduleRoute;
        }
    } , [redirectStatus, formId, moduleRoute])

    return redirectStatus
}import { getPromptModuleRouteFullUrl, promptFormsId, PromtRedirectStatus } from "../const/promptFormsId"
import { Team } from "@brg/api";
import { useCallback, useEffect, useMemo, useState } from "react";

type PropsT = Pick<Team, "teamId" | "membersIDs" | "ownersIDs" > & { designerId?: string };

export const useRedirectToPromptForms = ({ teamId, membersIDs, ownersIDs, designerId }: PropsT) => {
    const [redirectStatus, setRedirectStatus] = useState<PromtRedirectStatus>(PromtRedirectStatus.default)

    const formId = (promptFormsId[teamId as keyof {}] ?? '') as string; 
    const moduleRoute = getPromptModuleRouteFullUrl(formId);

    const isOwner = useMemo(() => {
        if (designerId && ownersIDs) {
            return ownersIDs?.includes(designerId ?? '')
        }
        return null
    } , [designerId, ownersIDs])

    const participant = useMemo(() => {
        if (designerId && membersIDs) {
            return membersIDs?.includes(designerId ?? '')
        }
        return null
    } , [designerId, membersIDs])

    const init = useCallback(() => {
        if (isOwner !== null && participant !== null && (isOwner || participant)) {
            setRedirectStatus(PromtRedirectStatus.member)
        } else {
            setRedirectStatus(PromtRedirectStatus.notMember)
        }
    } , [isOwner, participant, designerId])

    useEffect(() => {
        init()
    } , [isOwner, participant, designerId])

    useEffect(() => {
        if (redirectStatus === PromtRedirectStatus.member && formId && moduleRoute) {
            window.location.href = moduleRoute;
        }
    } , [redirectStatus, formId, moduleRoute])

    return redirectStatus
}